// extracted by mini-css-extract-plugin
export default {"helpModalContainer":"ReturnShipmentDetails_helpModalContainer__soWDn"};